// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"hk-fieldset-fieldset","legend":"hk-fieldset-legend"};